import {makeStyles} from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  dashedBorder: {
    border: '1px dashed',
    borderColor: theme.palette.primary.main,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  card: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  pieChartLegendWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: '20px',
    // width:"-moz-min-content",
    // alignItems: "flex-end",
    marginInlineEnd: theme.spacing(1),
  },
  gridItems: {
    paddingTop: '25px',
  },
  legendItemContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    // paddingRight:"15px",
  },
  text: {
    marginBottom: theme.spacing(2),
    fontWeight: '0.8rem',
  },
  //   tabelcell:{
  //     position: "fixed",
  // width: "71px",
  // height: "18px",
  // left: "434px",
  // top: "633px",

  // fontfamily: "Lato",
  // fontstyle: "normal",
  // fontweight: "bold",
  // fontsize: "8px",
  // lineheight: "18px",

  /* identical to box height, or 150% */
  // texttransform: "uppercase",

  // color: "#343A58",
  //   },
  name: {
    margin: 'inherit',
  },
  value: {
    margin: 'inherit',
  },
  Table: {
    whiteSpace: 'nowrap',
    fontsize: '0.25rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '6px',
    height: 'auto',
    backgroundColor: 'whitesmoke',
    fontWeight: 'bold',
  },

  TableCell: {
    height: 'auto',
    padding: '0px',
    fontSize: '0.7rem',
  },
  TableBody: {
    padding: '7px',
  },
  TableBodycell: {
    padding: '9px',
  },

  TableCellBody: {
    height: '7px',
    padding: '7px',
  },
  TableFooter: {
    padding: '12px',
    height: '7px',
  },
  TableFootercell: {
    height: '7px',
    padding: '7px',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: 'black',
  },
  // DayDropDown:{
  //   position:"absolute",
  //   right:"28px",
  //   top:"88px",
  //   color:"black",
  // },
  DaySelect: {
    // backgroundColor: "white",
    marginInlineStart: '40px',
    width: '110px',
    height: '30px',
    color: 'black',
    borderRadius: '7%',
    fontSize: '13px',
    border: 'groove',
    borderWidth: 'thin',
    borderColor: 'lightgray',
    textDecoration: 'none',
  },
  // firstGrid:{
  //   maxWidth:"31%",
  // },
  // RatingHead:{
  //   fontSize:"0.8rem",
  //   color:"rgba(104, 109, 136, 0.7);",
  // },
  // RatingsFlow:{
  //   fontSize:"0.95rem",
  //   padding:"6px 0px 14px 0px"
  // },
  // RatingsFlowGrid:{
  //   paddingTop:"15px",
  // },

  // RatingValue:{
  //   fontSize:"3rem",
  //   color:"#4964D9",
  // },
  // LinearProgress:{
  //   top:"-13px",
  //   left:"75px",
  //   width:"176px",
  //   height:"8px",
  //   backgroundColor:"darkcyen"
  // },
  // ValueCounts:{
  //   position:"absolute",
  //   right:"75px"
  // },
  valueStattistics: {
    textAlign: 'end',
    flex: '1',
  },
  DayDropDown: {
    alignItems: 'end',
    flex: '1',
  },
  pieChart: {
    transform: 'rotate(90deg)',
  },
	displayValue: {
		display: "flex",
		flexFlow: "column",
		paddingTop: "10px",
	},
}));
